import { apiClient } from '@/lib/api/client';
import { AuthTokens, User } from './store';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  role?: 'ADMIN' | 'VIEWER' | 'TIME_TRACKER';
}

export interface ForgotPasswordData {
  email: string;
}

export interface ResetPasswordData {
  token: string;
  newPassword: string;
}

export interface UpdateProfileData {
  name?: string;
  email?: string;
  password?: string;
}

export const authApi = {
  async login(credentials: LoginCredentials): Promise<AuthTokens> {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },

  async register(data: RegisterData): Promise<AuthTokens> {
    const response = await apiClient.post('/auth/register', data);
    return response.data;
  },

  async getProfile(token?: string): Promise<User> {
    const config = token
      ? {
          headers: { Authorization: `Bearer ${token}` },
        }
      : {};
    const response = await apiClient.get('/auth/profile', config);
    return response.data;
  },

  async refreshToken(refreshToken: string): Promise<AuthTokens> {
    const response = await apiClient.post('/auth/refresh', { refreshToken });
    return response.data;
  },

  async logout(refreshToken: string): Promise<void> {
    await apiClient.post('/auth/logout', { refreshToken });
  },

  async forgotPassword(data: ForgotPasswordData): Promise<{ message: string }> {
    const response = await apiClient.post('/auth/forgot-password', data);
    return response.data;
  },

  async resetPassword(data: ResetPasswordData): Promise<{ message: string }> {
    const response = await apiClient.post('/auth/reset-password', data);
    return response.data;
  },

  async updateProfile(data: UpdateProfileData): Promise<User> {
    const response = await apiClient.patch('/auth/profile', data);
    return response.data;
  },

  async deleteAccount(): Promise<void> {
    await apiClient.delete('/auth/profile');
  },
};
